<template>
  <sub-nav>
    <template v-if="$store.state.Session.logined">
      <b-nav-item key="result"
        href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
        <router-link :to="'/result'+queryParam">今日のできごと</router-link>
      </b-nav-item>
      <b-nav-item key="status"
        href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
        <router-link :to="'/status'+queryParam">ステータス</router-link>
      </b-nav-item>
    </template>
    <b-nav-item key="list"
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/list">キャラクターリスト</router-link>
    </b-nav-item>
    <b-nav-item key="worldlist"
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/world">異世界リスト</router-link>
    </b-nav-item>
    <template v-if="$store.state.Session.logined">
      <b-nav-item key="map"
        href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
        <router-link to="/map">地図</router-link>
      </b-nav-item>
    </template>
  </sub-nav>
</template>

<script>
import SubNav from './SubNav'
export default {
  name: 'result-nav',
  components: { SubNav },
  props: {
    eno: {
      type: String,
      default: null
    }
  },
  computed: {
    queryParam () {
      return this.eno ? '/'+this.eno : ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
